export default __webpack_public_path__ + "static/1676-a074799b67e0dc4e9eba6cb8b852aa79.gif";